import { getStateInformation } from 'apis/scoringVoucherAPI';
import useAsync from 'hooks/base/useAsync';
import { isNil } from 'lodash';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import GlobalStore from 'stores/globalStore';

interface TokenParam {
  token: string;
}

const GetStateApi = () => {
  const { status, execute, value } = useAsync(getStateInformation, false);
  const { session } = GlobalStore.useContainer();
  const navigate = useNavigate();

  React.useEffect(() => {
    execute(session);
  }, [execute, session]);

  const getStateApi = React.useCallback(
    (params: TokenParam) => {
      execute(params.token);
    },
    [execute]
  );

  React.useEffect(() => {
    if (isNil(value)) {
      return;
    }

    if (value.error) {
      // message.error(value.errorMessage);
      return;
    }
  }, [navigate, value]);

  return {
    isLoading: status === 'pending',
    getStateApi,
    state: value
  };
};

export default GetStateApi;
